/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import {
  Grid,
  GridColumn as Column,
  getSelectedState
} from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import {
  CirclePlus,
  CircleX,
  LucideFileDigit,
  SlidersHorizontal
} from "lucide-react";
import { Link } from "react-router-dom";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Checkbox,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import Layout from "components/layout";
import {
  useGetATMList,
  useGetCustomers,
  useGetShiftRoutes,
  useValidateBulkOrders
} from "utils/apis/lookups.api";
import {
  isOperationAllowed,
  onSealFileUploadPayload,
  readOnlyExcelDate,
  showToast
} from "utils/helper";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { formatDate } from "date-fns";
import {
  useGetReplenishmentRequests,
  useAssignReplenishmentRoute,
  useCancelReplenishmentService,
  useCreateReplenishmentBulkOrders,
  useAssignBagSeals,
  useValidateBulkBagsAssignment
} from "utils/apis/replenishment.api";
import OpenModelRequests from "components/openModelRequests";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";
import DownloadTemplate from "./download-template";
import { LookUpContext } from "utils/reducers/lookup";
import { ExcelExport } from "@progress/kendo-react-excel-export";

const pageSize = 25;
const currentDate = new Date();

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc"
    }
  ]
};

export default function Replenishment() {
  const user = useContext(UserContext);
  const { allBagTypes, coinContainers, currencies } = useContext(LookUpContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [openModelLocations, setOpenModelLocations] = useState(false);
  const [routesTeams, setRoutesTeams] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>(
    user?.filters?.replenishment || {}
  );

  const [openSealFileUpload, setOpenSealFileUpload] = useState(false);
  const [sealAssignType, setSealAssignType] = useState("");
  const [bagSealData, setBagSealData] = useState<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [selectedRequests, setSelectedRequests] = useState<any[]>([]);

  const [btnAssignRouteDis, setBtnAssignRouteDis] = useState(true);
  const [btnAssignRouteTxt, setBtnAssignRouteTxt] = useState("Assign Route");
  const [btnCancelDis, setBtnCancelDis] = useState(true);
  const [btnCancelTxt, setBtnCancelTxt] = useState("Cancel");

  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;

  const { data: atmLocations } = useGetATMList(filters?.customer?.id);
  const { data: customers } = useGetCustomers();
  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    )
  });

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests
  } = useGetReplenishmentRequests({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceSPId?.id || "",
    isPrepack: filters?.isPrepack?.id || false,
    isBranchToATM: filters?.isBranchToATM?.id || false
  });

  const {
    mutate: validateReplenishmentBulkOrders,
    isPending: validateOrdersPending,
    isSuccess: validateOrdersSuccess,
    isError: validateOrdersError,
    data: validateData,
    reset: validateReset
  } = useValidateBulkOrders();

  const {
    mutate: createBulkOrders,
    isPending: bulkOrderPending,
    isSuccess: bulkOrderSuccess,
    isError: bulkOrderError,
    data: bulkCreationResponseData
  } = useCreateReplenishmentBulkOrders();

  const {
    mutate: cancelService,
    isSuccess: cancelSuccess,
    isError: cancelError
  } = useCancelReplenishmentService();

  const {
    mutate: assignRoute,
    isSuccess: assignRouteSuccess,
    isError: assignRouteError
  } = useAssignReplenishmentRoute();

  const {
    mutate: validateBulkBagsAssignment,
    isPending: validateBulkBagsAssignmentPending,
    isSuccess: validateBulkBagsAssignmentSuccess,
    isError: validateBulkBagsAssignmentError,
    reset: validateBagReset
  } = useValidateBulkBagsAssignment();

  const {
    mutate: assignBagSeals,
    isPending: assignBagSealsPending,
    isSuccess: assignBagSealsSuccess,
    isError: assignBagSealsError,
    data: assignBagData
  } = useAssignBagSeals();

  const routesTeamsList = useRef<any[]>([]);

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
  };

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedRequests = selections.filter(
      (req) => req.isSelected === true
    );

    const requestIds: any = selectedRequests.map((req) => ({
      itemKey: req.itemKey
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File | null;
    if (!fileObj) return;
    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "csv"
      ].includes(fileObj.type)
    )
      return showToast("error", "File format not supported.");

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        // reset previous parsed list
        routesTeamsList.current = [];

        const rows = resp?.rows || [];
        if (!rows.length) {
          showToast("error", "Excel file is empty.");
          return;
        }
        // parse each data row starting from 2nd row (index 1)
        for (let idx = 1; idx < rows.length; idx += 1) {
          const row = rows[idx] || [];
          // skip entirely empty rows
          const allEmpty = row.every(
            (c: any) => c === null || c === undefined || String(c).trim() === ""
          );
          if (allEmpty) continue;

          const sourceBarcode = row[0];
          const onwardBarcode = row[1];
          const serviceDate = row[2];
          const invoicingModel = row[3];
          const jobNature = row[4];
          const jobType = row[5];
          const priority = row[6];
          const routeNo = row[7];
          const requestedBy = row[8];

          // skip if both barcodes  is missing
          if (!sourceBarcode && !onwardBarcode) continue;

          routesTeamsList.current.push({
            sourceBarcode: String(sourceBarcode || "").trim(),
            onwardBarcode: String(onwardBarcode || "").trim(),
            serviceDate: readOnlyExcelDate(serviceDate),
            invoicingModel,
            priority,
            jobType,
            jobNature,
            routeNo,
            shift: "morning",
            requestedBy
          });
        }
        if (routesTeamsList.current.length > 0) {
          setRoutesTeams([...routesTeamsList.current]);
          validateReplenishmentBulkOrders([...routesTeamsList.current]);
        } else {
          showToast("error", "No valid data found in Excel file.");
        }
      }
    });
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: {
          name: formatDate(value, "PPP"),
          id: value
        }
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        replenishment: {
          ...filters,
          operationDate: {
            name: formatDate(value, "PPP"),
            id: value
          }
        }
      });
    }
    setCurrentPage(1);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: {
        name: e.target.value,
        id: e.target.value
      }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      replenishment: {
        ...filters,
        searchCriteria: {
          name: e.target.value,
          id: e.target.value
        }
      }
    });
  };

  const showPrePackOrders = (e: boolean) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      isPrepack: {
        name: `Pre Pack Orders`,
        id: e
      }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      replenishment: {
        ...filters,
        isPrepack: {
          name: `Pre Pack Orders`,
          id: e
        }
      }
    });
  };

  const showBranchToATMOrders = (e: boolean) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      isBranchToATM: {
        name: `Branch To ATM Orders`,
        id: e
      }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      replenishment: {
        ...filters,
        isBranchToATM: {
          name: `Branch To ATM Orders`,
          id: e
        }
      }
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceSPId, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val)
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      replenishment: {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val)
      }
    });
  };

  const handleSourceSPId = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceSPId", val);
  };
  const handleCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const onConfirmFileOrders = () => {
    createBulkOrders(routesTeams);
  };

  const onDdlInRouteTeamsChanged = (value: string) => {
    if (!value) {
      setDdlInRouteTeams("");
      return;
    }

    setDdlInRouteTeams(value);

    if (selectedRequests.length > 0) setBtnAssignRouteDis(false);
    else setBtnAssignRouteDis(true);
  };

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const cashCenterId = filters?.cashCenter?.id || user.CashCenterId;
    const routeNo = ddlInRouteTeams;

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1]
    }));

    const assignmentDto: any = {
      cashCenterId,
      operationDate: formatDate(
        filters?.operationDate?.id || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      routeNo,
      shift: "morning",
      requests: requestsIds
    };

    setBtnAssignRouteDis(true);
    setBtnAssignRouteTxt("Assigning...");
    assignRoute(assignmentDto);
  };

  const onAssignSealModal = (type: string) => {
    setOpenSealFileUpload(true);
    setSealAssignType(type);
  };

  const onSealFileUpload = async (event: any) => {
    const payload = await onSealFileUploadPayload(
      event,
      sealAssignType,
      allBagTypes,
      coinContainers,
      currencies
    );
    setBagSealData(payload);
    validateBulkBagsAssignment(payload);
  };
  const onConfirmBagSeals = () => {
    assignBagSeals(bagSealData);
  };

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    setBtnCancelDis(true);
    setBtnCancelTxt("Canceling...");

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1]
    }));

    cancelService(requestsIds);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {isOperationAllowed(Permissions.Replenishment, Permissions.View) ? (
          <Link
            to="/replenishment-detail"
            state={{
              requestId,
              jobNo
            }}
          >
            {orderId}
          </Link>
        ) : (
          orderId
        )}
      </td>
    );
  }

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  useEffect(() => {
    if (validateOrdersError || validateData) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
      routesTeamsList.current = [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError, validateData]);

  useEffect(() => {
    if (bulkOrderSuccess) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
      routesTeamsList.current = [];
    }
    if (bulkOrderError) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
      validateReset();
      routesTeamsList.current = [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkOrderSuccess, bulkOrderError]);

  useEffect(() => {
    if (cancelSuccess) {
      setBtnCancelDis(true);
      setBtnCancelTxt("Cancel");
      setSelectedState({});
    }
    if (cancelError) {
      setBtnCancelDis(false);
      setBtnCancelTxt("Cancel");
    }
  }, [cancelError, cancelSuccess]);

  useEffect(() => {
    if (validateBulkBagsAssignmentError) {
      setOpenSealFileUpload(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
      validateBagReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateBulkBagsAssignmentError]);

  useEffect(() => {
    if (assignRouteSuccess) {
      setDdlInRouteTeams("");
      setBtnAssignRouteTxt("Assign Route");
      setSelectedState({});
    }
    if (assignRouteError) {
      setBtnAssignRouteDis(false);
      setBtnAssignRouteTxt("Assign Route");
    }
  }, [assignRouteError, assignRouteSuccess]);

  useEffect(() => {
    if (assignBagSealsSuccess) {
      setOpenSealFileUpload(false);
      setBagSealData([]);
      validateBagReset();
    }

    if (assignBagSealsError) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
      validateBagReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagSealsSuccess, assignBagSealsError]);

  useEffect(() => {
    if (assignBagData?.consignments?.length) {
      excelExport1?.save(assignBagData?.consignments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagData]);

  useEffect(() => {
    if (bulkCreationResponseData?.length) {
      excelExport2?.save(bulkCreationResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkCreationResponseData]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Replenishment </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId
                        }),
                        label: item.name
                      }))}
                      setValue={handleCustomer}
                    />
                    <Combobox
                      value={JSON.stringify(filters?.sourceSPId) || ""}
                      placeholder="Select Location"
                      data={atmLocations?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item?.servicePointId
                        }),
                        label: `${item.barcode}-${item.locationId}`
                      }))}
                      setValue={handleSourceSPId}
                    />
                  </div>
                </PopoverContent>
              </Popover>
              <div className="w-[15%]">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || currentDate}
                  onSelectDate={onOperationDateChanged}
                />
              </div>
              {isOperationAllowed(
                Permissions.Replenishment,
                Permissions.Edit
              ) ? (
                <div className="w-[15%]">
                  <Combobox
                    setValue={onDdlInRouteTeamsChanged}
                    value={ddlInRouteTeams}
                    placeholder="Select Route"
                    data={inRouteTeams?.map((item: any) => ({
                      value: item?.routeNo,
                      label: `${item.routeNo} (${item.description})`
                    }))}
                  />
                </div>
              ) : null}

              <div className="w-[10%]">
                {loadingRequests ? (
                  <div className="text-end">
                    <Loader size="large" type="pulsing" />
                  </div>
                ) : null}
              </div>

              <div className="flex-1 flex justify-end gap-2">
                {isOperationAllowed(
                  Permissions.Replenishment,
                  Permissions.Add
                ) ? (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <CirclePlus />
                        Create Request
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-[180px]">
                      <DropdownMenuItem>
                        <Link
                          to="/create-replenishment"
                          state={{ createType: "single" }}
                        >
                          Single Request
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          setOpenFileUpload(true);
                        }}
                        className="cursor-pointer"
                      >
                        Bulk Requests
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : null}
                {isOperationAllowed(
                  Permissions.Replenishment,
                  Permissions.Edit
                ) ? (
                  <Button
                    variant="secondary"
                    disabled={btnAssignRouteDis}
                    onClick={onBtnAssignRouteClicked}
                  >
                    {btnAssignRouteTxt}
                  </Button>
                ) : null}
                {isOperationAllowed(
                  Permissions.Replenishment,
                  Permissions.Edit
                ) ? (
                  <DownloadTemplate
                    operationDate={filters?.operationDate?.id || new Date()}
                  />
                ) : null}
                {isOperationAllowed(
                  Permissions.Replenishment,
                  Permissions.Edit
                ) && (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <LucideFileDigit /> Bulk Bags Assignment
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start" className="w-[180px]">
                      <DropdownMenuItem
                        onClick={() => {
                          onAssignSealModal("Small Denominations");
                        }}
                        className="cursor-pointer"
                      >
                        Small Denominations
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          onAssignSealModal("AED & Coins");
                        }}
                        className="cursor-pointer"
                      >
                        AED & Coins
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                )}
                {/* {isOperationAllowed(
                  Permissions.Replenishment,
                  Permissions.Cancel,
                ) ? ( */}
                <Button
                  variant="secondary"
                  disabled={btnCancelDis}
                  onClick={onBtnCancelClicked}
                >
                  {btnCancelTxt}
                </Button>
                {/* ) : null} */}
              </div>
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val?.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null
              )}
            </div>
            <div className="border-b mb-3 bg-accent" />
            <div className="flex justify-between mb-3">
              <div className="flex gap-3">
                <div className="items-center flex gap-2">
                  <Checkbox
                    id="isPrepack-checkbox"
                    checked={filters?.isPrepack?.id}
                    onCheckedChange={showPrePackOrders}
                  />
                  <label
                    className="cursor-pointer"
                    htmlFor="isPrepack-checkbox"
                  >
                    Pre Pack Order
                  </label>
                </div>
                <div className="items-center flex gap-2">
                  <Checkbox
                    id="IsBranchToATM-checkbox"
                    checked={filters?.isBranchToATM?.id}
                    onCheckedChange={showBranchToATMOrders}
                  />
                  <label
                    className="cursor-pointer"
                    htmlFor="IsBranchToATM-checkbox"
                  >
                    Branch To ATM Order
                  </label>
                </div>
              </div>
              {isOperationAllowed(
                Permissions.Replenishment,
                Permissions.Search
              ) ? (
                <Input
                  className="w-full max-w-[420px]"
                  value={filters?.searchCriteria?.id}
                  onChange={onFilterSearch}
                  title="Search: Job No., Job Nature, Status, Route No., Shift"
                  placeholder="Search: Job No., Job Nature, Status, Route No., Shift"
                />
              ) : null}
            </div>
            <Grid
              className="text-xs"
              dataItemKey={DATA_ITEM_KEY}
              selectedField={SELECTED_FIELD}
              selectable={{
                enabled: true,
                drag: true,
                cell: false,
                mode: "multiple"
              }}
              data={process(
                requestsData?.data?.map((req: any) => ({
                  ...req,
                  [SELECTED_FIELD]: selectedState[idGetter(req)]
                })) || [],
                {
                  ...dataState,
                  skip: 0
                }
              )}
              {...dataState}
              pageable
              onPageChange={onPageChange}
              pageSize={pageSize}
              total={totalRecords}
              skip={(currentPage - 1) * pageSize}
              take={pageSize}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              onSelectionChange={onSelectionChange}
              onHeaderSelectionChange={onHeaderSelectionChange}
              size="small"
            >
              <Column
                field={SELECTED_FIELD}
                filterable={false}
                width="40px"
                headerSelectionValue={
                  requestsData?.data?.findIndex(
                    (item: any) => !selectedState[idGetter(item)]
                  ) === -1
                }
              />
              <Column
                field="orderId"
                title="Order Id"
                cell={ShowDetailsButtonCell}
                width={160}
              />
              <Column title="Job #" width={80} field="jobNo" />

              <Column field="customer" title="Customer" />
              <Column field="barcode" title="Barcode" />
              <Column field="locationId" title="Location Id" />
              <Column field="locationName" title="Location Name" />
              <Column
                field="routeNo"
                title="Route"
                width={140}
                className="text-center"
                headerClassName="text-center"
              />
              <Column field="jobNature" title="Job Nature" />
              <Column field="jobType" title="Job Type" />
              <Column field="requestedBy" title="Requested By" width={140} />
              <Column
                field="status"
                title="Status"
                className="text-center"
                headerClassName="text-center"
                width={140}
              />
            </Grid>
            <ExcelExport
              ref={(exporter) => {
                excelExport1 = exporter;
              }}
              fileName={`Replenishment_Bags_Assignment_${new Date().toLocaleString()}.xlsx`}
              columns={[
                { field: "serviceDate", title: "Service Date" },
                { field: "routeNo", title: "Route No" },
                { field: "sourceBarcode", title: "Source Barcode" },
                { field: "onwardBarcode", title: "Onward Barcode" },
                { field: "sealNo", title: "Seal No" },
                { field: "containerType", title: "Bag Type" },
                { field: "currency", title: "Currency" },
                { field: "declaredValue", title: "Value" },
                { field: "denominations", title: "Coins Denomination" },
                { field: "denomination", title: "Note Denomination" },
                { field: "notes", title: "Notes" },
                { field: "assigmentStatus", title: "Status" },
                { field: "locationId", title: "Location ID" }
              ]}
            />
            <ExcelExport
              ref={(exporter) => {
                excelExport2 = exporter;
              }}
              fileName={`Replenishment_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
              columns={[
                { field: "sourceBarcode", title: "Source Barcode" },
                { field: "onwardBarcode", title: "Onward Barcode" },
                {
                  field: "invoicingModel",
                  title: "Invoicing Model"
                },
                { field: "jobType", title: "Job Type" },
                { field: "jobNature", title: "Job Nature" },
                { field: "routeNo", title: "Route No" },
                { field: "priority", title: "Priority" },
                { field: "serviceDate", title: "Service Date" },
                { field: "requestedBy", title: "Requested By" },
                { field: "status", title: "Status" },
                { field: "message", title: "Message" }
              ]}
            />
          </CardDescription>
        </CardContent>
      </Card>
      <Dialog open={openFileUpload} onOpenChange={setOpenFileUpload}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Orders</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {routesTeams?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now add orders.
                </p>
                <Button
                  variant="secondary"
                  onClick={onConfirmFileOrders}
                  isLoading={validateOrdersPending || bulkOrderPending}
                  disabled={!validateOrdersSuccess || bulkOrderPending}
                >
                  Add orders
                </Button>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
      {/* Assign Seal Orders */}

      <Dialog
        open={openSealFileUpload}
        onOpenChange={() => {
          setBagSealData([]);
          setOpenSealFileUpload(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{sealAssignType} Bags Assignment</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {bagSealData.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{bagSealData.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmBagSeals}
                    isLoading={
                      validateBulkBagsAssignmentPending || assignBagSealsPending
                    }
                    disabled={
                      !validateBulkBagsAssignmentSuccess ||
                      assignBagSealsPending
                    }
                  >
                    Assign Seals
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      if (fileInputRef.current) fileInputRef.current.value = "";
                      setBagSealData([]);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onChange={onSealFileUpload}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <OpenModelRequests
        openFileUpload={openModelLocations}
        setOpenFileUpload={setOpenModelLocations}
      />
    </Layout>
  );
}
